import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { compose, not } from 'ramda';
import { withHandlers } from 'recompose';

import connect from 'app/libs/connect';
import Button from 'app/components/Button/Button';
import translations from 'app/features/localization/translations.json';
import { HERO } from 'app/analytics/constants/positions';
import { subscriptionRequested } from 'app/features/products/actions';
import { checkoutUrlBySelectedBillingPlan } from 'app/features/checkout/selectors';
import {
  isBillingPlanSelected,
  selectedPlanSku,
} from 'app/features/billing/selectors';

const UI = ({ onClick, isDisabled, checkoutUrl, testId, textKey }) => (
  <Button
    as="a"
    type={isDisabled ? 'disabled' : 'one'}
    to={isDisabled ? '' : checkoutUrl}
    testId={testId}
    onClick={onClick}
  >
    <FormattedMessage id={textKey} />
  </Button>
);

UI.propTypes = {
  onClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  testId: PropTypes.string.isRequired,
  textKey: PropTypes.string.isRequired,
  checkoutUrl: PropTypes.string,
};

UI.defaultProps = {
  checkoutUrl: '',
};

UI.displayName = 'CheckoutButton';

const onClick =
  ({ subscriptionRequested, sku, textKey }) =>
  () =>
    subscriptionRequested({
      sku,
      actionDetail: {
        position: HERO,
        textOfButtonOrLink: translations[textKey],
      },
    });

const state = {
  sku: selectedPlanSku,
  isDisabled: compose(not, isBillingPlanSelected),
  checkoutUrl: checkoutUrlBySelectedBillingPlan,
};
const actions = { subscriptionRequested };

const CheckoutButton = compose(
  connect(state, actions),
  withHandlers({ onClick }),
)(UI);

export { UI, onClick };

export default CheckoutButton;
